import React, { useContext, useState } from "react";
import { Dialog, DialogContent, Box, Slide, Button } from "@mui/material";
import { useStakingContract } from "../../Connectivity/Hooks";
import { toast } from "react-toastify";
import Loading from "../../Components/Loading";
import { withStyles } from "@mui/styles";
import { AppContext } from "../../utils";
// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

const StyledButton = ({ children, ...props }) => {
  return (
    <Button
      {...props}
      sx={{
        // background: "#F7C35F",
        background: "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
        borderRadius: "4px",
        padding: "15px 20px",
        border: "none",
        outline: "none",
        color: "#ffffff",

        fontSize: "16px",
        lineHeight: "19px",
        fontWeight: "400",
        marginRight: "10px",
      }}
    >
      {children}
    </Button>
  );
};

const StyledModal = withStyles(() => ({
  root: {
    "& .MuiDialog-root": {
      zIndex: "1301 !important",
    },
    "&.MuiDialog-container": {
      overflowY: "hidden !important",
    },
    "& .MuiDialog-paperScrollPaper": {
      backgroundColor: "#1C6179 !important",
      height: "auto",
      boxShadow: "0px 0px 8px 1px",
      border: "5px solid black",
      borderRadius: "20px",
    },
    "& .dialoge__content__section": {
      background: "#1C6179 !important",
      // borderRadius: 5,
    },
    "& .MuiDialogContent-root": {
      paddingTop: "20px",
      paddingBottom: "20px",
    },
  },
}))(Dialog);

function UnstakeModal({ open, setOpen, unstakeIndex, inits }) {
  const { account, signer } = useContext(AppContext);
  const stakingContract = useStakingContract(signer);
  const [loading, setloading] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const unstakeHandler = async () => {
    try {
      setloading(true);
      const tx = await stakingContract.unStake(unstakeIndex);
      await tx.wait();
      toast.success("Success! Amount successfully unsataked.");
      inits();
      setloading(false);
    } catch (error) {
      if (error?.data?.message) {
        toast.error(error?.data?.message);
      } else {
        toast.error(error?.message);
      }
      setloading(false);
    }
  };

  return (
    <div>
      <Loading loading={loading} />
      <div className="modal__main__container">
        <StyledModal
          open={open}
          keepMounted
          //   TransitionComponent={Transition}
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent className="dialoge__content__section">
            <Box
              textAlign="center"
              fontSize="17px"
              fontFamily="Expletus Sans"
              color="#fff"
            >
              You have to pay 15% potential penality
            </Box>

            <Box
              mt={2}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <StyledButton onClick={() => handleClose()}>Cancel</StyledButton>
              <StyledButton
                onClick={() => {
                  unstakeHandler();
                  handleClose();
                }}
              >
                Unstake
              </StyledButton>
            </Box>
          </DialogContent>
        </StyledModal>
      </div>
    </div>
  );
}

export default UnstakeModal;
